import React from "react";
import coursesData from "../../utils/ListEnrolledCourses.json";

const RelatedContent = () => {
  // Filter courses based on the required conditions
  const filteredCourses = coursesData.courses.filter(
    (course) => !course.isEnrolled && course.isUpcoming
  );

  return (
    <div className="related-content bg-gray-100 py-8 px-4 ">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Related Content</h2>
      {filteredCourses.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 m-2">
          {filteredCourses.map((course) => (
            <div
              key={course.id}
              className="related-card bg-white shadow-lg shadow-blue-600 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-200"
            >
              <img
                src={course.image}
                alt={course.title}
                className="w-full h-40 object-cover"
              />
              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-800">
                  {course.title}
                </h3>
                <p className="text-gray-600 text-sm mt-2">
                  {course.description}
                </p>
                <p className="text-gray-500 text-sm mt-2">
                  <strong>Teacher:</strong> {course.teacher}
                </p>
                <p className="text-gray-500 text-sm mt-2">
                  <strong>Start Time:</strong>{" "}
                  {new Date(course.startTime).toLocaleString()}
                </p>
                <button className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200">
                  Enroll
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-600">No related content available.</p>
      )}
    </div>
  );
};

export default RelatedContent;
